import gql from 'graphql-tag';
import actionTypes from './constants';

/* */
export const getCalendar = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_CALENDAR}`,
  fetchPolicy,
  variables,
})
  .then(({ data }) => ({ events: data.getEventsCalendar }));

/* */
export const getEvent = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_EVENT}`,
  fetchPolicy,
  variables,
})
  .then(({ data }) => (data.getEvent));

/* */
export const getEntryFees = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_ENTRY_FEES}`,
  fetchPolicy,
  variables,
})
  .then(({ data }) => ({ fees: data.getEntryFees }));

/* */
export const setEntry = (client, variables) => client.mutate({
  mutation: gql`${actionTypes.gql.SET_ENTRY}`,
  variables,
})
  .then(({ data }) => data.setEntry);

/* */
export const getEntryList = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_ENTRY_LIST}`,
  fetchPolicy,
  variables,
})
  .then(({ data }) => ({ entries: data.getEventEntryList }))
// DEBUG
  .catch(() => ({ entries: [] }));

/* */
export const getMyEvents = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_MY_EVENTS}`,
  fetchPolicy,
  variables,
})
  .then(({ data }) => data.getMyEvents);

/* */
export const getSalesOrder = (client, id, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_EVENT_ORDER}`,
  fetchPolicy,
  variables: { id },
})
  .then(({ data }) => data.getEventOrder);

/* */
export const cancel = (client, id) => client.mutate({
  mutation: gql`${actionTypes.gql.CANCEL_EVENT}`,
  variables: { id },
})
  .then(({ data }) => data.cancelEvent);
